import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import styles from './mostrames.module.scss';

export default function MostraMes(props) {
    const { titol, titolTema, link, linkTipus, slug, slug2, estil, estilBoto, novaFinestra = false, isBlanc = false } = props;
    let text = titol;
    const label = titolTema ? `${text} ${titolTema}` : text;
    const route = {
        href: link,
        type: linkTipus,
        slug: slug,
        slug2: slug2
    };

    const styleMostraMes = clsx({
        [styles.mostraMes]: true,
        [styles[estil]]: !!estil
    });

    if (link || linkTipus) {
        return (
            <div className={styleMostraMes}>
                <Enllac
                    estil={estilBoto}
                    route={route}
                    className={styles.mostraMes_btn}
                    ariaLabel={label}
                    title={label}
                    novaFinestra={novaFinestra}
                >
                    {text}
                </Enllac>
                {estil !== 'totes' && <Icona icona='fletxa_simple_dreta' isBlanc={isBlanc} />}
            </div>
        );
    } else {
        return <></>;
    }
}
